// extracted by mini-css-extract-plugin
export var chip = "_nc-0";
export var icon = "_nc-1";
export var remove = "_nc-2";
export var removeIcon = "_nc-3";